import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from '@/utils/request'
import { hasPermission,getDictLabel } from './utils/common'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/main.scss'
// import VueAMap from 'vue-amap'

import * as echarts from 'echarts'
import "echarts-gl"

import VueAnimateNumber from 'vue-animate-number'

import {loading,borderBox13,digitalFlop,capsuleChart,borderBox8,borderBox10,borderBox1,scrollRankingBoard} from '@jiaminghi/data-view'
import Echart from './components/echart/index.vue'
import ItemWrapDef from './components/item-wrap/item-wrap-def.vue'


Vue.config.productionTip = false

Vue.use(ElementUI);
// Vue.use(VueAMap);
Vue.use(VueAnimateNumber)
// VueAMap.initAMapApiLoader({
//   key: 'ee9e86e54f213cc5984bd3f6269a51f8',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 
//   'AMap.CircleEditor','AMap.Geocoder', 'AMap.Geolocation'],
//   v: '1.4.4'
// });

// 自定义组件
Vue.component("Echart",Echart)
Vue.component("ItemWrapDef",ItemWrapDef)
// datav组件
Vue.use(loading)
Vue.use(borderBox1)
Vue.use(borderBox13)
Vue.use(borderBox8)
Vue.use(borderBox10)
Vue.use(scrollRankingBoard)
Vue.use(digitalFlop)
Vue.use(capsuleChart)

http({
  url: http.adornUrl('/bus/dict/getDictList'),
  method: 'get'
}).then(({ data }) => {
  if (data.code === 200) {
    let d_data = data.data
    window.SITE_CONFIG['dictList'] = data.data
    let o_data = {}
    d_data.forEach(item => {
      let dictType = item.dictType
      o_data[dictType] = item.dataList
    })
    console.log('字典：',  o_data)
    // 挂载全局
    Vue.prototype.$dictData = o_data
    Vue.prototype.$http = http
    Vue.prototype.$hasPermission = hasPermission
    Vue.prototype.$getDictLabel = getDictLabel
    Vue.prototype.$echarts = echarts
    let innerHeight = window.innerHeight
    Vue.prototype.$innerHeightRadio = innerHeight / 937
    // 全局过滤器
    Vue.filter('transDict',(val,dictName) => {
      if (val !== '' && val !== undefined && dictName) {
        let selectItem = Vue.prototype.$dictData[dictName].find(item => Number(item.dictValue) == Number(val))
        return selectItem.dictLabel
      }
      return ''
    })
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
